import { css } from 'lit';

export default css`
  :host {
    display: block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
    --list-min-width: 300px;
    --list-item-bg: var(--color-gray-1, #f7f5f4);
    --list-item-border: 1px solid var(--color-white, #ffffff);
    --list-item-hover-bg: var(--color-gray-2, #e8e7e6);
    --list-item-padding: var(--spacing-md, 16px);
    --list-border-radius: 8px;
  }

  .list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    margin: 0;
    min-width: var(--list-min-width);
    list-style: none;
  }

  .list-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: var(--list-item-padding);
    width: 100%;
    background: var(--list-item-bg);
    border-bottom: var(--list-item-border);
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .list-item:hover {
    background-color: var(--list-item-hover-bg);
  }

  .list-item.first {
    border-top-left-radius: var(--list-border-radius);
    border-top-right-radius: var(--list-border-radius);
  }

  .list-item.last {
    border-bottom-left-radius: var(--list-border-radius);
    border-bottom-right-radius: var(--list-border-radius);
    border-bottom: none;
  }

  .list-item:first-child:last-child {
    border-radius: var(--list-border-radius);
    border-bottom: var(--list-item-border);
  }

  ::slotted([slot^="content-"]) {
    width: 100%;
  }

  @media (max-width: 768px) {
    .list {
      min-width: 100%;
    }
  }
`;